import React from "react";
import { CheckCircle2, XCircle, AlertCircle, Info } from "lucide-react";

const Alert = ({ type = "success", message, className = "" }) => {
  const styles = {
    alert: {
      display: "flex",
      alignItems: "center",
      padding: "16px",
      borderRadius: "8px",
      border: "1px solid",
      borderLeft: "4px solid",
      width: "100%",
    },
    content: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },
    icon: {
      flexShrink: 0,
      width: "16px",
      height: "16px",
    },
    text: {
      fontSize: "14px",
      fontWeight: 500,
      margin: 0,
    },
  };

  const typeStyles = {
    success: {
      background: "#ecfdf5",
      borderColor: "#a7f3d0",
      borderLeftColor: "#10b981",
      color: "#047857",
      iconColor: "#10b981",
    },
    error: {
      background: "#fef2f2",
      borderColor: "#fecaca",
      borderLeftColor: "#ef4444",
      color: "#b91c1c",
      iconColor: "#ef4444",
    },
    warning: {
      background: "#fffbeb",
      borderColor: "#fde68a",
      borderLeftColor: "#f59e0b",
      color: "#b45309",
      iconColor: "#f59e0b",
    },
    info: {
      background: "#eff6ff",
      borderColor: "#bfdbfe",
      borderLeftColor: "#3b82f6",
      color: "#1e40af",
      iconColor: "#3b82f6",
    },
  };

  const defaultMessages = {
    success: "Please check your email inbox for a link to complete the reset.",
    error: "An error occurred. Please try again.",
    warning: "Please review your information before proceeding.",
    info: "Your session will expire in 5 minutes.",
  };

  const selectedType = typeStyles[type] || typeStyles.success;
  const IconComponent =
    {
      success: CheckCircle2,
      error: XCircle,
      warning: AlertCircle,
      info: Info,
    }[type] || CheckCircle2;

  const combinedAlertStyles = {
    ...styles.alert,
    background: selectedType.background,
    borderColor: selectedType.borderColor,
    borderLeftColor: selectedType.borderLeftColor,
  };

  return (
    <div style={combinedAlertStyles}>
      <div style={styles.content}>
        <IconComponent
          style={{
            ...styles.icon,
            color: selectedType.iconColor,
          }}
        />
        <span
          style={{
            ...styles.text,
            color: selectedType.color,
          }}
        >
          {message || defaultMessages[type]}
        </span>
      </div>
    </div>
  );
};
export default Alert;
